import { Dropdown } from '@joor/design-system'
import styled from 'styled-components'

export const Container = styled.div`
  label {
    margin: 0;
  }
`

export const StyledDropdown = styled(Dropdown)`
  margin-bottom: 14px;
  width: 400px;
  border-radius: 4px !important;
  border-color: var(--color-primary-400) !important;

  & input {
    font-family: var(--font-family-alpha) !important;
    line-height: var(--line-height-16) !important;
    width: auto !important;
  }

  &:hover {
    border-color: var(--color-primary-800) !important;
  }
`

export const TextFieldWrapper = styled.div`
  margin-bottom: 14px;
  width: 400px;
  border-radius: 4px !important;
  border-color: var(--color-primary-400) !important;

  & > label {
    display: block;
  }

  &:hover {
    border-color: var(--color-primary-800) !important;
  }
`

export const AlertContainer = styled.div`
  border-radius: 6px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 0 0 8px;
  gap: 8px;

  &.warning {
    border: 1px solid var(--color-warning-500);
    background-color: var(--color-warning-100);
  }

  &.info {
    border: 1px solid var(--color-secondary-400);
    background-color: var(--color-secondary-200);
  }
`
